export enum RelationClassification {
  FINANCIAL_RESPONSIBLE = 'FINANCIAL_RESPONSIBLE',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  PHI_AUTHORIZED = 'PHI_AUTHORIZED',
}

export enum AuthServer {
  GOOGLE,
  MICROSOFT,
}

export enum NotificationSource {
  TASK = 'TASK',
  WORKFLOW = 'WORKFLOW',
  FOLLOW_UP = 'FOLLOW_UP',
}

export enum NotificationScope {
  TASK = 'TASK',
  WORKFLOW = 'WORKFLOW',
  FOLLOW_UP = 'FOLLOW_UP',
  PATIENT = 'PATIENT',
}

export enum NotificationTarget {
  USER = 'USER',
  CONTACT = 'CONTACT',
  SYSTEM = 'SYSTEM',
}

export enum NotificationTrigger {
  TASK_STARTED = 'TASK_STARTED',
  TASK_COMPLETED = 'TASK_COMPLETED',
  TASK_ASSIGNED = 'TASK_ASSIGNED',
  TASK_FOLLOWING = 'TASK_FOLLOWING',
  FOLLOWUP_ASSIGNED = 'FOLLOWUP_ASSIGNED',
  WORKFLOW_ASSIGNED = 'WORKFLOW_STARTED',
  WORKFLOW_COMPLETED = 'WORKFLOW_COMPLETED',
}
